import { Glyph } from "@/components/Ornaments";

const ITEMS = [
  "Original Soundtracks",
  "Tabletop Scores",
  "Game Design Documents",
  "Creative Direction",
  "Volt VMC × Electronic Arts",
];

const Group = () => (
  <div className="flex items-center gap-10 pr-10">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center gap-10">
        <span className="font-display text-xs md:text-sm uppercase tracking-[0.4em] text-slate-400">
          {t}
        </span>
        <Glyph className="w-3 h-3 text-gold/60" />
      </span>
    ))}
  </div>
);

const Marquee = ({ className = "" }) => (
  <div className={`marquee-band overflow-hidden border-y border-line bg-[#0a0a0e] py-5 ${className}`} data-testid="marquee-band">
    <div className="marquee-track flex w-max items-center">
      <Group />
      <Group />
    </div>
  </div>
);

export default Marquee;
